import { Label, Description } from '@heroui/react';

/**
 * Form-row scaffold: label on top, control below, optional hint underneath.
 * Single source of truth for the settings-modal field vocabulary. The label
 * and hint are HeroUI primitives (Label / Description) so they stay
 * accessible and on-theme; the muted caption colour is preserved via
 * className to match the dense settings layout.
 */
export function Field(props: {
  label: string;
  hint?: string;
  /** Marks the field required — appends a required indicator to the label. */
  required?: boolean;
  /** Optional inline element to the right of the label (counter, error). */
  trailing?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-baseline justify-between gap-2">
        <Label className="text-[13px] font-medium text-ink" isRequired={props.required}>
          {props.label}
        </Label>
        {props.trailing}
      </div>
      {props.children}
      {props.hint && (
        <Description className="text-xs leading-snug text-ink-muted">
          {props.hint}
        </Description>
      )}
    </div>
  );
}
